module.exports = __webpack_public_path__ + "img/whats-new-6_cn.2c16443.jpg";